import React, {Component} from 'react';
import {Link, matchPath, withRouter} from "react-router-dom";
import Rooms from './../components/Rooms';
import {bindActionCreators} from "redux";
import {fetchRooms} from "../../../../creators/rooms";
import {archivedRoom, leaveRoom, lockRoom, readRoom, removeRoomByUser} from "../../../../creators/room";
import {connect} from "react-redux";
import {getRoomsWithFilter} from "../../../../selectors/rooms";
import Icon from "../../../components/Icon";
import Dropdown from "../../../components/Dropdown";
import {Can} from "../../../../ability-context";
import _ from "lodash";
import {toast} from "react-toastify";

const getParams = (base, pathname) => {
    const matchProfile = matchPath(pathname, {
        path: `${base}/:room`,
    });
    return (matchProfile && matchProfile.params) || {};
};

class Messenger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: {
                limit: 20,
                sort: "-updatedAt",
                page: 1,
                archived: false,
            },
            selectedRoomId: null,
            read: true,
            ownerOnline: false,
        };
        this.handleRoomMarkRead = _.debounce(this.handleRoomMarkRead, 100);
    }

    componentDidMount() {
        this._getRooms();
    }

    _getRooms(more) {
        let filter = {
            ...this.state.filter,
        };
        if (!this.state.read) filter.read = false;
        this.props.fetchRooms(filter, more);
    }

    _handleReadFilter() {
        this.setState({read: !this.state.read}, () => this._getRooms())
    }

    _handleArchivedFilter() {
        this.setState({filter : {...this.state.filter, archived: !this.state.filter.archived}}, () => this._getRooms())
    }

    _handleOpenRoom(roomId) {
        this.props.history.push(`${this.props.match.url}/${roomId}`);
    }

    _handleRoomLock(roomId, isLocked) {
        this.props.lockRoom(roomId, {locked: isLocked});
    }

    handleRoomMarkRead(roomId, isRead) {
        this.props.readRoom(roomId, {read: isRead})
    }

    _handleShowMore() {
        this.setState({filter: {...this.state.filter, page: this.state.filter.page + 1}}, () => this._getRooms(true));
    }

    _filteredRooms(rooms) {
        rooms = rooms.filter(room => (this.state.ownerOnline ? room.hasUserOnline : true));
        rooms = rooms.filter(room => room.currentUserIsArchived === this.state.filter.archived);
        return rooms;
    }

    _handleRoomArchived(roomId,isAchived) {
        if(isAchived){
            toast("Cette conversation vient d'être archivée. Vous pouvez retrouver les conversations archivées en cliquant sur Filtres / Conversations archivées.",{
                autoClose: 15000,
                className: 'toast-background toast-success',
                bodyClassName: "toast-font toast-success",
                progressClassName: 'toast-loader toast-success'
            });
        }

        this.props.archivedRoom(roomId, {archived: isAchived});

    }

    _handleRemoveRoom(roomId){
        this.props.removeRoomByUser(roomId);
    }

    render() {
        let currentRoomId = getParams(this.props.match.path, this.props.location.pathname).room || null;
        return (
            <div className="sidebar left room-list">
                <div className="wrapper-sidebar-left">
                    <div className="title">Messagerie</div>
                    <Can action="create" subject={"Room"}><Link className="pointer flex" to={`${this.props.match.url}/new`}><Icon type="pencil-square"
                                                                                            className="mr-4"/> Créer
                        un chat</Link></Can>
                </div>
                <div className="title-rooms">
                    <span>Liste des discussions</span>
                    <Dropdown align="right" activableComponent={(
                        <span className="rooms-filter">Filtres <Icon type="cog"/></span>
                    )}>
                        <div className="dropdown-menu">
                            <li className="menu-item"
                                onClick={() => this.setState({ownerOnline: !this.state.ownerOnline})}><Icon
                                type={"user-online"}/> {this.state.ownerOnline ? `Tous les Contacts` : `Contacts en ligne`}
                            </li>
                            <li className="menu-item" onClick={() => this._handleReadFilter()}><Icon
                                type={"envelope-o"}/> {this.state.read ? `Conversations non lues` : `Toutes les conversations`}
                            </li>
                            <li className="menu-item" onClick={() => this._handleArchivedFilter()}><Icon
                                type={"archive"}/> {this.state.filter.archived ? `Conversations non achivées` : `Conversations achivées`}
                            </li>
                        </div>
                    </Dropdown>
                </div>
                <Rooms
                    handleOpenRoom={this._handleOpenRoom.bind(this)}
                    handleShowMore={this._handleShowMore.bind(this)}
                    handleRoomLock={this._handleRoomLock.bind(this)}
                    handleRoomMarkRead={this.handleRoomMarkRead.bind(this)}
                    rooms={this._filteredRooms(this.props.rooms)}
                    roomsTotal={this._filteredRooms(this.props.rooms).length}
                    selectedRoomId={currentRoomId}
                    more={this.props.roomsMore}
                    handleRoomArchived={this._handleRoomArchived.bind(this)}
                    handleRemoveRoom={this._handleRemoveRoom.bind(this)}
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        rooms: getRoomsWithFilter(state),
        roomsLoading: state.rooms.loading,
        roomsInitialized: state.rooms.initialized,
        roomsMore: state.rooms.more
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRooms,
    leaveRoom,
    lockRoom,
    readRoom,
    archivedRoom,
    removeRoomByUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Messenger));